import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowFitBottomLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.749 18.001A2.75 2.75 0 0 1 2 15.251v-8.5a.75.75 0 1 1 1.5 0v8.5q0 .09.012.177L15.441 3.5H10.25a.75.75 0 1 1 0-1.5H18v7.75h-.75.75a.75.75 0 0 1-1.5 0h.75-.75V4.561L4.573 16.489q.086.012.176.012h8.501a.75.75 0 0 1 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomLeft20);
